import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync, LL_H_C, TS_AppTools, TS_ErrorBoundary } from '@nu-art/thunderstorm-frontend/index';
import { Advisor_ErrorBoundary } from './Advisor_ErrorBoundary.js';
import './ATS_AdvisorErrorBoundary.scss';
import { Second } from '@nu-art/ts-common';
export class ATS_AdvisorErrorBoundary extends ComponentSync {
    static Screen = {
        name: 'Advisor Error Boundary',
        key: 'advisor-error-boundary',
        group: 'Components',
        renderer: this,
    };
    render() {
        return _jsxs(_Fragment, { children: [TS_AppTools.renderPageHeader('Advisor Error Boundary'), _jsxs(LL_H_C, { className: 'ats-advisor-error-boundary', children: [_jsx(ErrorBoundaryPanel, { height: 500 }), _jsx(ErrorBoundaryPanel, { height: 350 }), _jsx(ErrorBoundaryPanel, { height: 200 })] })] });
    }
}
class ErrorBoundaryPanel extends ComponentSync {
    deriveStateFromProps(nextProps, state) {
        if (!state.error)
            setTimeout(() => {
                this.setState({ error: new Error() });
            }, Second);
        return state;
    }
    render() {
        return _jsx("div", { style: { height: this.props.height }, className: 'error-boundary-panel__wrapper', children: _jsx(TS_ErrorBoundary, { error: this.state.error, renderer: (e) => _jsx(Advisor_ErrorBoundary, { error: e, panelKey: 'ATS', dir: this.props.height <= 250 ? 'horizontal' : 'vertical', onClick: () => this.reDeriveState({ error: undefined }) }), children: _jsx("div", { className: 'error-boundary-panel__content', children: "Panel Content" }) }) });
    }
}
//# sourceMappingURL=ATS_AdvisorErrorBoundary.js.map